import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import s from './MapNoteSheetEditable.module.scss';

export default class MapNoteTypeDropdown extends Component {
    static propTypes = {
        selected: PropTypes.string,
        onOptionClick: PropTypes.func,
    };

    static defaultProps = {
        selected: '---',
        onOptionClick: () => {},
    };

    constructor(props) {
        super(props);
        this.state = { showOptions: false };
    }

    changeTypeFormat = type => {
        switch (type) {
            case 'mapRequest':
                return 'Map Request';
            case 'fieldVerify':
                return 'Field Verify';
            case 'Map Request':
                return 'mapRequest';
            case 'Field Verify':
                return 'fieldVerify';
            default:
                return '---';
        }
    };

    onOptionClick = e => {
        this.props.onOptionClick(this.changeTypeFormat(e.currentTarget.dataset.id));
        this.setState({ showOptions: false });
    };

    renderOptions = () => {
        const noLabelCheckmark = classNames(s.checkmarkIcon, this.props.selected === '---' || this.props.selected === null ? s.show : s.hide);
        const mapRequestCheckmark = classNames(s.checkmarkIcon, this.props.selected === 'Map Request' || this.props.selected === 'mapRequest' ? s.show : s.hide);
        const fieldVerifyCheckmark = classNames(s.checkmarkIcon, this.props.selected === 'Field Verify' || this.props.selected === 'fieldVerify' ? s.show : s.hide);
        return (
            <div className={s.optionsContainer}>
                <button className={classNames(s.option, s.removeButtonStyling)} type="button" onClick={this.onOptionClick} data-id="—--">
                    <div className={classNames(s.label, s.noLabel)}>---</div>
                    <img className={noLabelCheckmark} src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg" alt="Checkmark Icon" />
                </button>
                <button className={classNames(s.option, s.removeButtonStyling)} type="button" onClick={this.onOptionClick} data-id="Map Request" data-testid="map-request-option">
                    <div className={classNames(s.label, s.mapRequest)}>Map Request</div>
                    <img className={mapRequestCheckmark} src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg" alt="Checkmark Icon" />
                </button>
                <button className={classNames(s.option, s.removeButtonStyling)} type="button" onClick={this.onOptionClick} data-id="Field Verify">
                    <div className={classNames(s.label, s.fieldVerify)}>Field Verify</div>
                    <img className={fieldVerifyCheckmark} src="https://content.locuslabs.com/vms-ui/map-note-icons/tick-new-gray.svg" alt="Checkmark Icon" />
                </button>
            </div>
        );
    };

    render() {
        const { showOptions } = this.state;
        const selectedLabel = classNames(s.selectedLabel, s.label, s[`${this.props.selected}`], { [s.noLabel]: this.props.selected === 'noType' || this.props.selected === '---' });
        return (
            <div className={s.typeDropdown}>
                <div className={s.visibleDropdownWrapper}>
                    <div className={s.typeLabel}>Type</div>
                    <button data-testid="map-note-type-button" className={s.selectedOptionWrapper} type="button" onClick={() => this.setState({ showOptions: !showOptions })}>
                        <div className={selectedLabel}>{this.changeTypeFormat(this.props.selected)}</div>
                        <div className={classNames(s.icon, showOptions ? 'icon-triangleup' : 'icon-triangledown')} />
                    </button>
                </div>
                {showOptions && this.renderOptions()}
            </div>
        );
    }
}
